<template>
  <v-dialog scrollable persistent v-model="dialogShow" max-width="1300px">
    <template v-slot:activator="{ on }">
      <v-tooltip left v-on="on">
        <template v-slot:activator="{ on }">
          <v-btn
            v-if="addButton"
            v-on="on"
            dark
            small
            fab
            color="primary"
            @click="openForm()"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <span>Adicionar condomínio</span>
      </v-tooltip>
    </template>

    <v-card>
      <v-system-bar color="primary" dark>
        <v-spacer></v-spacer>
        <v-icon color="#fff" @click="closeForm">close</v-icon>
      </v-system-bar>

      <v-card-title class="mb-0 pb-0">
        <span class="title grey--text text--darken-2">
          {{ setTitleForm(formData.id) }}
        </span>
      </v-card-title>

      <v-card-text class="mt-0 pt-0">
        <v-progress-circular
          v-if="loadingDataSheet"
          indeterminate
          color="primary"
        ></v-progress-circular>
        <v-form
          v-else
          style="min-height: 400px"
          ref="datasheetForm"
          v-model="validForm"
          lazy-validation
          class="mt-0 pt-0"
        > 
          <v-layout mt-4>
            <v-flex cols="4" mx-4>
              <v-select
                :items="condominiumType"
                label="Tipo"
                v-model="formData.type"
                :disabled="viewForm"
                :rules="$store.state.formRules.required"
                required
              ></v-select>
            </v-flex>
          </v-layout>

          <v-layout style="max-height: 290px;">
            <v-flex cols="4" mx-4>
              <v-text-field
                :disabled="viewForm"
                suffix="m²"
                type="number"
                v-model="formData.land_footage"
                label="Área total"
                :rules="$store.state.formRules.required"
                required
              ></v-text-field>
            </v-flex>

            <v-flex cols="4" mx-4>
              <v-text-field
                :disabled="viewForm"
                suffix="m²"
                type="number"
                v-model="formData.built_area_footage"
                label="Área construída"
                :rules="$store.state.formRules.required"
                required
              ></v-text-field>
            </v-flex>
                  
            <v-flex cols="4" mx-4>
              <v-text-field
                :disabled="viewForm"
                suffix="m²"
                type="number"
                v-model="formData.boma_footage"
                label="Área Boma"
                :rules="$store.state.formRules.required"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex cols="6" mx-4>
              <v-text-field
                :disabled="viewForm"
                v-model="formData.unities"
                min="1"
                type="number"
                label="Unidades"
                :rules="$store.state.formRules.required"
                required
              ></v-text-field>
            </v-flex>

            <v-flex cols="6" mx-4>
              <v-text-field
                :disabled="viewForm"
                v-model="formData.floors"
                min="1"
                type="number"
                label="Andares"
                :rules="$store.state.formRules.required"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex cols="4" mx-4 style="max-width: 300px;">
              <v-switch
                :disabled="viewForm"
                v-model="formData.socialElevator.has"
                label="Elevador Social"
                color="primary"
                hide-details
              ></v-switch>
            </v-flex>

            <template v-if="formData.socialElevator.has">
              <v-flex cols="8">
                <v-layout>
                  <v-flex cols="3" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      min="1"
                      type="number"
                      v-model="formData.socialElevator.quantity"
                      label="Quantidade"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="3" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      min="1"
                      type="number"
                      v-model="formData.socialElevator.velocity"
                      label="Velocidade"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="3" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.socialElevator.weight"
                      label="Peso"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="3" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.socialElevator.year"
                      label="Ano fabricação"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout>
                  <v-flex cols="12" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.socialElevator.description"
                      label="Descrição"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </template>
          </v-layout>

          <v-layout>
            <v-flex cols="4" mx-4 style="max-width: 300px;">
              <v-switch
                :disabled="viewForm"
                v-model="formData.serviceElevator.has"
                label="Elevador Serviço"
                color="primary"
                hide-details
              ></v-switch>
            </v-flex>

            <template v-if="formData.serviceElevator.has">
              <v-flex cols="8">
                <v-layout>
                  <v-flex cols="3" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      min="1"
                      type="number"
                      v-model="formData.serviceElevator.quantity"
                      label="Quantidade"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="3" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      min="1"
                      type="number"
                      v-model="formData.serviceElevator.velocity"
                      label="Velocidade"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="3" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.serviceElevator.weight"
                      label="Peso"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="3" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.serviceElevator.year"
                      label="Ano fabricação"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout>
                  <v-flex cols="12" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.serviceElevator.description"
                      label="Descrição"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </template>
          </v-layout>

          <v-layout>
            <v-flex cols="4" mx-4 style="max-width: 300px;">
              <v-switch
                :disabled="viewForm"
                v-model="formData.electricSystem.has"
                label="Sistema elétrico"
                color="primary"
                hide-details
              ></v-switch>
            </v-flex>

            <template v-if="formData.electricSystem.has">
              <v-flex cols="8">
                <v-layout>
                  <v-flex cols="6" mx-4>
                    <v-select
                      :items="condominiumVoltage"
                      label="Classificação"
                      v-model="formData.electricSystem.classification"
                      :disabled="viewForm"
                    ></v-select>
                  </v-flex>

                  <v-flex cols="6" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      min="1"
                      type="number"
                      v-model="formData.electricSystem.voltage"
                      label="Voltagem"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout>
                  <v-flex cols="12" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.electricSystem.description"
                      label="Descrição"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </template>
          </v-layout>

          <v-layout>
            <v-flex cols="4" mx-4 style="max-width: 300px;">
              <v-switch
                :disabled="viewForm"
                v-model="formData.generator.has"
                label="Gerador"
                color="primary"
                hide-details
              ></v-switch>
            </v-flex>

            <template v-if="formData.generator.has">
              <v-flex cols="8">
                <v-layout>
                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.generator.quantity"
                      label="Quantidade"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.generator.capacity"
                      label="Capacidade"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.generator.brand"
                      label="Marca"
                    ></v-text-field>
                  </v-flex>
        
                  <v-flex cols="4" mx-4>
                    <v-select
                      :items="condominiumGenerator"
                      label="Área abrangida"
                      v-model="formData.generator.area"
                      :disabled="viewForm"
                    ></v-select>
                  </v-flex>

                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.generator.year"
                      label="Ano fabricação"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout>
                  <v-flex cols="12" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.generator.description"
                      label="Descrição"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </template>
          </v-layout>

          <v-layout>
            <v-flex cols="4" mx-4 style="max-width: 300px;">
              <v-switch
                :disabled="viewForm"
                v-model="formData.air_conditioning_vrf.has"
                label="Ar condicionado - VRF"
                color="primary"
                hide-details
              ></v-switch>
            </v-flex>

            <template v-if="formData.air_conditioning_vrf.has">
              <v-flex cols="8">
                <v-layout row wrap>
                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.air_conditioning_vrf.quantity"
                      label="Quantidade"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.air_conditioning_vrf.capacity"
                      label="Capacidade"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.air_conditioning_vrf.type"
                      label="Tipo"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.air_conditioning_vrf.quantityTrs"
                      label="Quantidade TRs"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.air_conditioning_vrf.perEquipament"
                      label="Por equipamento"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.air_conditioning_vrf.brand"
                      label="Marca"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="4" mx-4>
                    <v-switch
                      :disabled="viewForm"
                      v-model="formData.air_conditioning_vrf.open"
                      label="Em aberto"
                      color="primary"
                      hide-details
                    ></v-switch>
                  </v-flex>

                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.air_conditioning_vrf.year"
                      label="Ano fabricação"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                
                <v-layout>
                  <v-flex cols="12" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.air_conditioning_vrf.description"
                      label="Descrição"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </template>
          </v-layout>

          <v-layout>
            <v-flex cols="4" mx-4 style="max-width: 300px;">
              <v-switch
                :disabled="viewForm"
                v-model="formData.air_conditioning_chillers.has"
                label="Ar condicionado - Chillers"
                color="primary"
                hide-details
              ></v-switch>
            </v-flex>

            <template v-if="formData.air_conditioning_chillers.has">
              <v-flex cols="8">
                <v-layout row wrap>
                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.air_conditioning_chillers.quantity"
                      label="Quantidade"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.air_conditioning_chillers.capacity"
                      label="Capacidade"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.air_conditioning_chillers.type"
                      label="Tipo"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.air_conditioning_chillers.quantityTrs"
                      label="Quantidade TRs"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.air_conditioning_chillers.perEquipament"
                      label="Por equipamento"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.air_conditioning_chillers.brand"
                      label="Marca"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="4" mx-4>
                    <v-switch
                      :disabled="viewForm"
                      v-model="formData.air_conditioning_chillers.open"
                      label="Em aberto"
                      color="primary"
                      hide-details
                    ></v-switch>
                  </v-flex>

                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.air_conditioning_chillers.year"
                      label="Ano fabricação"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                
                <v-layout>
                  <v-flex cols="12" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.air_conditioning_chillers.description"
                      label="Descrição"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </template>
          </v-layout>

          <v-layout>
            <v-flex cols="4" mx-4 style="max-width: 300px;">
              <v-switch
                :disabled="viewForm"
                v-model="formData.air_conditioning_tower.has"
                label="Ar condicionado - Torre"
                color="primary"
                hide-details
              ></v-switch>
            </v-flex>

            <template v-if="formData.air_conditioning_tower.has">
              <v-flex cols="8">
                <v-layout row wrap>
                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.air_conditioning_tower.quantity"
                      label="Quantidade"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.air_conditioning_tower.capacity"
                      label="Capacidade"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.air_conditioning_tower.type"
                      label="Tipo"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.air_conditioning_tower.quantityTrs"
                      label="Quantidade TRs"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.air_conditioning_tower.perEquipament"
                      label="Por equipamento"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.air_conditioning_tower.brand"
                      label="Marca"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="4" mx-4>
                    <v-switch
                      :disabled="viewForm"
                      v-model="formData.air_conditioning_tower.open"
                      label="Em aberto"
                      color="primary"
                      hide-details
                    ></v-switch>
                  </v-flex>

                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.air_conditioning_tower.year"
                      label="Ano fabricação"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                
                <v-layout>
                  <v-flex cols="12" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.air_conditioning_tower.description"
                      label="Descrição"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </template>
          </v-layout>

          <v-layout>
            <v-flex cols="4" mx-4 style="max-width: 300px;">
              <v-switch
                :disabled="viewForm"
                v-model="formData.ete.has"
                label="Estação de tratamento de esgoto - ETE"
                color="primary"
                hide-details
              ></v-switch>
            </v-flex>

            <template v-if="formData.ete.has">
              <v-flex cols="4" mx-4>
                <v-text-field
                  :disabled="viewForm"
                  v-model="formData.ete.volume"
                  label="Volume"
                  type="number"
                  suffix="m³"
                ></v-text-field>
              </v-flex>
            </template>
          </v-layout>

          <v-layout>
            <v-flex mx-4 style="max-width: 300px;">
              <v-switch
                :disabled="viewForm"
                v-model="formData.eta.has"
                label="Estação de tratamento de água - ETA"
                color="primary"
                hide-details
              ></v-switch>
            </v-flex>

            <template v-if="formData.eta.has">
              <v-flex mx-4>
                <v-text-field
                  :disabled="viewForm"
                  v-model="formData.eta.volume"
                  label="Volume"
                  type="number"
                  suffix="m³"
                ></v-text-field>
              </v-flex>
            </template>
          </v-layout>

          <v-layout>
            <v-flex cols="4" mx-4 style="max-width: 300px;">
              <v-switch
                :disabled="viewForm"
                v-model="formData.fire_alarm.has"
                label="Sistema incêndio"
                color="primary"
                hide-details
              ></v-switch>
            </v-flex>

            <template v-if="formData.fire_alarm.has">
              <v-flex cols="8">
                <v-layout>
                  <v-flex cols="6" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.fire_alarm.brand"
                      label="Marca"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="6" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      min="1"
                      type="number"
                      v-model="formData.fire_alarm.year"
                      label="Ano fabricação"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout>
                  <v-flex cols="12" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.fire_alarm.description"
                      label="Descrição"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </template>
          </v-layout>

          <v-layout>
            <v-flex cols="4" mx-4 style="max-width: 300px;">
              <v-switch
                :disabled="viewForm"
                v-model="formData.fire_bomb.has"
                label="Bomba de incêndio"
                color="primary"
                hide-details
              ></v-switch>
            </v-flex>

            <template v-if="formData.fire_bomb.has">
              <v-flex cols="8">
                <v-layout>
                  <v-flex cols="6" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      min="1"
                      type="number"
                      v-model="formData.fire_bomb.quantity"
                      label="Quantidade"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="6" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.fire_bomb.brand"
                      label="Marca"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="6" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.fire_bomb.capacity"
                      label="Capacidade"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="6" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      min="1"
                      type="number"
                      v-model="formData.fire_bomb.year"
                      label="Ano fabricação"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout>
                  <v-flex cols="12" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.fire_bomb.description"
                      label="Descrição"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </template>
          </v-layout>

          <v-layout>
            <v-flex cols="4" mx-4 style="max-width: 300px;">
              <v-switch
                :disabled="viewForm"
                v-model="formData.access_control.has"
                label="Controle de acesso"
                color="primary"
                hide-details
              ></v-switch>
            </v-flex>

            <template v-if="formData.access_control.has">
              <v-flex cols="8">
                <v-layout>
                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      min="1"
                      type="number"
                      v-model="formData.access_control.quantity"
                      label="Quantidade"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.access_control.brand"
                      label="Marca sistema"
                    ></v-text-field>
                  </v-flex>
                  
                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      min="1"
                      type="number"
                      v-model="formData.access_control.quantityTicketGate"
                      label="Quantidade catraca"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.access_control.brandTicketGate"
                      label="Marca catraca"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout>
                  <v-flex cols="12" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.access_control.description"
                      label="Descrição"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </template>
          </v-layout>

          <v-layout>
            <v-flex cols="4" mx-4 style="max-width: 300px;">
              <v-switch
                :disabled="viewForm"
                v-model="formData.parking.has"
                label="Estacionamento"
                color="primary"
                hide-details
              ></v-switch>
            </v-flex>

            <template v-if="formData.parking.has">
              <v-flex cols="8">
                <v-layout>
                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      min="1"
                      type="number"
                      v-model="formData.parking.quantitySubsoil"
                      label="Quantidade subsolos"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      min="1"
                      type="number"
                      v-model="formData.parking.quantityCarSpots"
                      label="Quantidade vagas veículos"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      min="1"
                      type="number"
                      v-model="formData.parking.quantityMotocycleSpots"
                      label="Quantidade vagas motos"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      min="1"
                      type="number"
                      v-model="formData.parking.quantityBikeSpots"
                      label="Quantidade vagas bicicletas"
                    ></v-text-field>
                  </v-flex>

                  <v-flex cols="4" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      min="1"
                      type="number"
                      v-model="formData.parking.quantityDocks"
                      label="Quantidade docas"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout>
                  <v-flex cols="12" mx-4>
                    <v-text-field
                      :disabled="viewForm"
                      v-model="formData.parking.description"
                      label="Descrição"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </template>
          </v-layout>

          <v-layout>
            <v-flex cols="4" mx-4 style="max-width: 300px;">
              <v-switch
                :disabled="viewForm"
                v-model="formData.certifications.has"
                label="Certificações"
                color="primary"
                hide-details
              ></v-switch>
            </v-flex>

            <template v-if="formData.certifications.has">
              <v-flex cols="8">
                <v-text-field
                  v-if="!viewForm"
                  v-model="certificationToAdd"
                  @click:append="addCertification"
                  v-on:keydown.enter.prevent="addCertification"
                  label="Insira o nome da certificação e pressione Enter"
                ></v-text-field>

                <v-list>
                  <v-list-tile
                    v-for="(item, index) in formData.certifications.items"
                    :key="index"
                  >
                    <v-list-tile-content>
                      {{ item }}
                    </v-list-tile-content>

                    <v-list-tile-action>
                      <v-icon color="primary" @click="removeCertification(index)" v-if="!viewForm">close</v-icon>
                    </v-list-tile-action>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </template>
          </v-layout>

          <v-layout>
            <v-flex cols="4" mx-4 style="max-width: 300px;">
              <v-switch
                :disabled="viewForm"
                v-model="formData.attachments.has"
                label="Anexos"
                color="primary"
                hide-details
              ></v-switch>
            </v-flex>

            <template v-if="formData.attachments.has">
              <v-flex cols="8">
                <v-layout>
                  <v-text-field
                    v-if="!viewForm"
                    v-model="attachmentToAdd"
                    @click:append="addAttachment"
                    v-on:keydown.enter.prevent="addAttachment"
                    label="Insira o nome do anexo e pressione Enter"
                  ></v-text-field>

                  <v-btn @click="pickFile" v-if="!viewForm">
                    Upload
                  </v-btn>
                  <input
                    id="logoIpt"
                    type="file"
                    style="display: none"
                    ref="image"
                    accept="*"
                    @change="onFilePicked"
                  />
                </v-layout>

                <v-list>
                  <v-list-tile
                    v-for="(item, index) in formData.attachments.items"
                    :key="index"
                  >
                    <v-list-tile-content>
                      {{ item.description }}
                    </v-list-tile-content>

                    <v-list-tile-action>
                      <div>
                        <v-icon class="mr-2" @click="openAttachment(item.url)" v-if="item.url">remove_red_eye</v-icon>
                        <v-icon color="primary" @click="removeAttachment(index)" v-if="!viewForm">close</v-icon>
                      </div>
                    </v-list-tile-action>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </template>
          </v-layout>
        </v-form>
      </v-card-text>

      <v-card-actions style="border-top: 1px solid #eee">
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="downloadDatasheet"
          >Download</v-btn
        >

        <v-btn color="blueGrey darken-1" flat @click="closeForm"
          >Cancelar</v-btn
        >
        <v-btn v-if="!viewForm" color="primary" flat @click="saveDatasheet"
          >Salvar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import axios from 'axios'
import * as moment from 'moment'
import ToggleChecklist from '@/components/common/ToggleChecklist.vue'
import { getDatasheetCondominium, saveDatasheetCondominium } from '@/services/condominiuns'

const defaultDatasheet = {
  type: "",
  land_footage: 0,
  built_area_footage: 0,
  boma_footage: 0,
  unities: 0,
  floors: 0,
  air_conditioning_vrf: {
    has: false,
    quantity: "",
    capacity: "",
    type: "",
    quantityTrs: 0,
    perEquipament: "",
    brand: "",
    open: false,
    year: "",
    description: ""
  },
  air_conditioning_chillers: {
    has: false,
    quantity: "",
    capacity: "",
    type: "",
    quantityTrs: 0,
    perEquipament: "",
    brand: "",
    open: false,
    year: "",
    description: ""
  },
  air_conditioning_tower: {
    has: false,
    quantity: "",
    capacity: "",
    type: "",
    quantityTrs: 0,
    perEquipament: "",
    brand: "",
    open: false,
    year: "",
    description: ""
  },
  generator: {
    has: false,
    quantity: 0,
    capacity: "",
    brand: "",
    area: "",
    year: "",
    description: ""
  },
  socialElevator: {
    has: false,
    brand: "",
    quantity: 0
  },
  serviceElevator: {
    has: false,
    brand: "",
    quantity: 0
  },
  fire_alarm: {
    has: false,
    brand: "",
    year: 0,
    description: ""
  },
  fire_bomb: {
    has: false,
    quantity: 0,
    brand: "",
    capacity: "",
    year: 0,
    description: ""
  },
  parking: {
    has: false,
    quantitySubsoil: 0,
    quantityCarSpots: 0,
    quantityMotocycleSpots: 0,
    quantityBikeSpots: 0,
    quantityDocks: 0,
    description: ""
  },
  access_control: {
    has: false,
    quantity: 0,
    brand: "",
    quantityTicketGate: 0,
    brandTicketGate: "",
    description: ""
  },
  electricSystem: {
    has: false,
    classification: "",
    voltage: "",
    description: ""
  },
  ete: {
    has: false,
    volume: 0
  },
  eta: {
    has: false,
    volume: 0
  },
  certifications: {
    has: false,
    items: []
  },
  attachments: {
    has: false,
    items: []
  }
}

export default {
  name: 'DatasheetFormDlg',

  components: {
    ToggleChecklist,
  },

  props: {
    showPrepository: Function,
    prepositories: Array,
    addButton: Boolean,
    openForm: Function,
    closeForm: Function,
    saveCondominium: Function,
    dialog: Boolean,
    editFormData: Object,
    getCondominiums: Function,
    reopenFormFilled: Function,
    disableFields: { type: Boolean, default: false }
  },

  data () {
    return {
      condominiumId: 0,
      mandate_alert: '1',
      responsibleDialog: false,
      notifyFinancial: [],
      notifySindcationMandate: [],
      notify_documents_contracts: [],
      valDate: false,
      prepository: [],
      viewForm: false,
      tabs: [
        { id: 7, name: 'Ficha Técnica' },
      ],
      active: 1,
      validForm: true,
      formData: { ...defaultDatasheet },
      tableLogs: [],
      condominiumType: ["Corporativo", "Logístico"],
      condominiumVoltage: ["Alta", "Média", "Baixa"],
      condominiumGenerator: ["Privativa", "Comum", "Ambas"],
      certificationToAdd: "",
      attachmentToAdd: "",
      attachmentFile: "",
      attachmentName: "",
      attachmentAvatar: "",
      loadingDataSheet: false,
    }
  },

  computed: {
    certificate_expiration_date_formated: {
      get () {
        return this.formData.certificate_expiration_date
          ? moment(this.formData.certificate_expiration_date).format(
            'DD/MM/YYYY'
          )
          : ''
      },
      set (value) {
        if (value) {
          if (value.length < 10) return
          let arrs = value.split('/')
          let date = `${arrs[2]}-${arrs[1]}-${arrs[0]}`
          if (!moment(date).isValid()) {
            this.formData.certificate_expiration_date = new Date()
              .toISOString()
              .substr(0, 10)
            return
          }
          this.formData.certificate_expiration_date = date
        } else {
          this.formData.certificate_expiration_date = ''
        }
      }
    },
    dialogShow () {
      return this.dialog
    },
    condPermissions() {
      return this.$store.state.permissions.permissions.datasheet
    },
  },

  watch: {
    dialogShow (show) {
      if (show) {
        this.viewForm = this.editFormData.view
        
        this.condominiumId = this.editFormData.id
        this.getDatasheet()
      } else {
        this.condominiumId = 0
        this.formData = { ...defaultDatasheet }
        this.$refs.datasheetForm.resetValidation()
      }
    }
  },

  methods: {
    downloadDatasheet () {
      let obj = {
        url: 'api/technicalPlug/pdf',
        query: {
          condominium_id: this.condominiumId
        },
        method: 'post',
        filename: 'datasheet.pdf'
      }

      this.$store.dispatch('request/download', obj).then(response => {
        console.log('DOWNLOAD SUCCESS')
      })
    },

    setTitleForm (id) {
      let returnTitle

      if (id) {
        returnTitle = 'Editar condomínio'
      } else {
        returnTitle = 'Novo condomínio'
      }

      if (this.viewForm) {
        returnTitle = 'Visualização'
      }

      return returnTitle
    },

    pickFile () {
      this.$refs.image.click()
    },

    onFilePicked (e) {
      const files = e.target.files

      if (files[0] !== undefined) {
        this.formData.imageName = files[0].name
        if (this.formData.imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.formData.avatar = fr.result
          this.formData.imageFile = files[0] // this is an image file that can be sent to server...
        })
      } else {
        this.formData.imageName = ''
        this.formData.imageFile = ''
        this.formData.avatar = ''
      }
    },

    validTabs (tabs, btTabs, additionalRules) {
      for (let i = 0; i < tabs.length; i++) {
        if (tabs[i].getElementsByClassName('v-messages__message').length) {
          btTabs[i].classList.add('tabError')
        } else {
          btTabs[i].classList.remove('tabError')
        }
      }
      if (additionalRules.length) {
        for (let n = 0; n < additionalRules.length; n++) {
          if (!additionalRules[n].model.length) {
            btTabs[additionalRules[n].ind].classList.add('tabError')
          } else {
            btTabs[additionalRules[n].ind].classList.remove('tabError')
          }
        }
      }
    },

    openAttachment(url) {
      window.open(url)
    },

    async sendFile (file, name) {
      let USER_TOKEN = localStorage.getItem('token')
      let AuthStr = 'Bearer '.concat(USER_TOKEN)
      //let formData = new FormData()
      // formData.append(prop, data[prop]);
      //formData.append('id', id)
      //formData.append('avatar', file)

      axios.defaults.baseURL =
        process.env.NODE_ENV === 'production'
          ? process.env.VUE_APP_API_URL
          : /* 'http://187.103.137.78''http://192.168.20.41:9000''http://172.16.224.54:9000' */ process
            .env.VUE_APP_API_URL_DEV
      axios
        .post('/api/upload', {
            directory: "technicalPlug/", // INICIA SEM BARRA, FINALIZA COM BARRA, VC PODE PASSAR O QUE ACHAR BOM AQUI, E IDENTIFIQUE
            fileName: name, // NOME DO ARQUIVO, COM A EXTENSÃO DO ARQUIVO
            base64: `${await this.getBase64(file)}`
          }, 
          {
            headers: {
              Authorization: AuthStr
            }
          }
        )
        .then((resp) => {
          this.$store.commit('hideLoader')

          this.formData.attachments.items.push({
            description: this.attachmentToAdd,
            url: resp.data.url
          })

          this.attachmentName = ''
          this.attachmentFile = ''
          this.attachmentAvatar = ''
          this.attachmentToAdd = ""
        })
        .catch((error) => {
          let paramModal = {}
          paramModal.message = error.response
            ? error.response.data.errors
              ? Object.values(error.response.data.errors).join('<br>')
              : error.response.data.message
            : 'Contate o administrador do sistema'
          paramModal.title = 'Ocorreu erro'
          paramModal.type = 'error'
          paramModal.callback = null
          paramModal.btConfirm = {
            name: 'Ok',
            show: true
          }
          paramModal.btCancel = {
            show: false
          }
          this.$store.commit('hideLoader')
          this.$store.commit('confirmMessage/showConfirmMessage', paramModal)
        })
    },

    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },

    pickFile () {
      this.$refs.image.click()
    },

    onFilePicked (e) {
      const files = e.target.files

      if (files[0] !== undefined) {
        this.attachmentName = files[0].name
        if (this.attachmentName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.attachmentAvatar = fr.result
          this.attachmentFile = files[0] // this is an image file that can be sent to server...
        })
      } else {
        this.attachmentName = ''
        this.attachmentFile = ''
        this.attachmentAvatar = ''
      }
    },

    addCertification () {
      if (this.certificationToAdd) {
        this.formData.certifications.items.push(this.certificationToAdd)
      }

      this.certificationToAdd = ""
    },

    addAttachment () {
      if (this.attachmentToAdd) {
        if (this.attachmentFile && this.attachmentName) {
          this.sendFile(this.attachmentFile, this.attachmentName)
        } else {
          this.formData.attachments.items.push({
            description: this.attachmentToAdd,
            url: ""
          })

          this.attachmentName = ''
          this.attachmentFile = ''
          this.attachmentAvatar = ''
          this.attachmentToAdd = ""
        }
      }
    },

    removeCertification (index) {
      this.formData.certifications.items.splice(index, 1)
    },

    removeAttachment (index) {
      this.formData.attachments.items.splice(index, 1)
    },

    async saveDatasheet() {
      if (!this.$refs.datasheetForm.validate()) {
        let opts = {
          message: 'Verifique os campos no formulário',
          type: "danger",
        };

        this.$store.commit("showAlert", opts);  
        return
      } 
      
      this.loadingBtn = true

      const response = await saveDatasheetCondominium(this.formData, this.condominiumId)

      this.loadingBtn = false

      let opts = {
        message: 'Ficha técnica atualizada',
        type: "success",
      };

      this.$store.commit("showAlert", opts);

      this.closeForm()
    },

    async getDatasheet () {
      this.loadingDataSheet = true

      const response = await getDatasheetCondominium(this.condominiumId)

      this.formData = response

      if (!this.formData.attachments) {
        this.formData = {
          ...this.formData,
          attachments: {
            has: false,
            items: []
          }
        }
      }

      this.loadingDataSheet = false
    },
  }
}
</script>

<style>
.labelIcon {
  position: absolute;
  left: 3px;
  top: 15px;
  cursor: pointer;
}
.labelIcon i {
  font-size: 18px;
}
.iptFile input {
  opacity: 0;
}
.imgBox {
  overflow: hidden;
  display: flex;
  width: 200px;
  height: 200px;
  align-items: center;
  justify-content: center;
  margin: auto;
}
.delImage {
  font-size: 18px;
  color: #c62828 !important;
  cursor: pointer;
}
.addressCondominium .flex {
  padding-left: 20px;
  padding-top: 20px;
  padding-right: 20px;
}
#condominiumTab .v-tabs__bar {
  border-bottom: 1px solid #eee !important;
}

#condominiumTab .v-tabs__item.tabError {
  color: #c62828;
}
#condominiumTab .v-tabs__item.tabError::before {
  content: "*";
  color: #c62828;
}
</style>
